'use client'

import { BIRDIE_BALL_BASE, BIRDIE_BALL_SPHERE_FILL } from './GolfBall'
import type { BoardColumn } from './boardGeometry'

/**
 * The two column-header icons (B20 Task 2 item 6). They are the board's only
 * pictograms that are not a ball in a ring, and each says what its market is
 * ABOUT rather than decorating it:
 *
 *  - EXACT ORDER — a flag in the hole. The pin is the place the three putts are
 *    aimed at, so a market about the ORDER they arrive in is drawn as the target
 *    they arrive at.
 *  - ANY ORDER — two balls, one overlapping the other, sharing the tiles' own
 *    sphere gradient. Two balls with no sequence between them is the market.
 *
 * `aria-hidden` throughout: the header's word is the label, and every tile
 * carries its own full accessible name.
 */
export function BoardHeadIcon({ column }: Readonly<{ column: BoardColumn }>) {
  if (column === 'exact') {
    return (
      <svg aria-hidden="true" className="birdie-board__head-icon" viewBox="0 0 24 24">
        <ellipse
          cx="12"
          cy="19"
          fill="#0b120d"
          rx="7"
          ry="2.6"
          stroke="rgba(255,255,255,.5)"
          strokeWidth="0.9"
        />
        <path d="M11 19V4" stroke="#f3f3f3" strokeLinecap="round" strokeWidth="1.4" />
        <path d="M11.7 4.2h7.3l-2.6 3 2.6 3h-7.3z" fill="#ffcf3d" />
      </svg>
    )
  }
  return (
    <svg aria-hidden="true" className="birdie-board__head-icon" viewBox="0 0 24 24">
      <circle cx="8.5" cy="14" fill={BIRDIE_BALL_BASE} r="5.4" />
      <circle cx="8.5" cy="14" fill={BIRDIE_BALL_SPHERE_FILL} r="5.4" />
      <circle cx="16.5" cy="10" fill={BIRDIE_BALL_BASE} r="5.4" />
      <circle
        cx="16.5"
        cy="10"
        fill={BIRDIE_BALL_SPHERE_FILL}
        r="5.4"
        stroke="rgba(0,0,0,.35)"
        strokeWidth="0.6"
      />
      <g className="birdie-board__head-dimples">
        <circle cx="7" cy="12.5" r="0.6" />
        <circle cx="9.5" cy="12" r="0.6" />
        <circle cx="8" cy="15" r="0.6" />
        <circle cx="15" cy="8.5" r="0.6" />
        <circle cx="17.5" cy="8" r="0.6" />
        <circle cx="16" cy="11" r="0.6" />
      </g>
    </svg>
  )
}
